import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { Address, Person } from '@/types/parcel/orders/orders.interface';

interface LocationDataProps {
  Title: string;
  data: { address?: Partial<Address>; person?: Partial<Person>; notes: string };
  icon: React.ReactNode;
  actionButton?: React.ReactNode;
}

const LocationData = ({ Title, data, icon, actionButton }: LocationDataProps) => {
  const theme = useTheme();

  const textStyle = {
    span: {
      fontWeight: 'bold',
    },
    margin: '1rem 0',
    color: theme.palette.grey[800],
    textAlign: 'justify',
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
      <Grid size={{ xxs: 12 }} sx={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
        {icon}
        <Typography variant="h5" color={theme.palette.primary.main}>
          {Title}
        </Typography>
      </Grid>
      <Grid size={{ xxs: 12 }}>
        <Typography variant="body2" sx={textStyle}>
          {data.address?.address ?? ''}
        </Typography>
        <Typography variant="body2" sx={textStyle}>
          <span>Nombre: </span>
          {data.person?.firstName && `${data.person?.firstName}`}{' '}
          {data.person?.lastName && ` ${data.person?.lastName}`}
        </Typography>
        <Typography variant="body2" sx={textStyle}>
          <span>Teléfono: </span>
          {data.person?.phone ?? ''}
        </Typography>
        <Typography variant="body2" sx={textStyle}>
          <span>Referencias: </span>
          {data.address?.references || '-'}
        </Typography>
        {actionButton && <Box sx={{ mt: 2 }}>{actionButton}</Box>}
      </Grid>
    </Box>
  );
};

export default LocationData;
